import React from 'react';
import { IconsBox, PdfCard } from './style';
import { Box, Divider, IconButton, Skeleton, useTheme } from '@mui/material';

/**
 * DocumentCard
 *
 * A card component to display document/pdf-file/doc-file information with an icon, title, and description.
 * It includes a menu icon button for additional options.
 *
 * @param {Object} props - Component props
 * @param {Object} props.docData - Document data containing icon, title, and description.
 *
 * @returns {JSX.Element} - A styled card displaying document information.
 */
function DocumentCardSkeleton() {
    const theme = useTheme();
    return (
        <PdfCard>
            <IconsBox className="iconBox">
                <Skeleton variant="rounded" sx={{ height: '3rem', width: '3rem' }} />

                    <Skeleton variant="circular" sx={{ height: '1rem', width: '1rem' }} />
       
            </IconsBox>
            <Divider />

            <Box
                padding={{
                    xs: theme.typography.generic.xSmall,
                    sm: theme.typography.generic.xLarge,
                }}
            >
                <Skeleton variant="text" sx={{ height: '1.2rem', width: '50%' }} />
                <Skeleton variant="text" sx={{ height: '1.2rem', width: '30%' }} />
            </Box>
        </PdfCard>
    );
}

export default DocumentCardSkeleton;
